import http from '@frontend/api/http';
import { HYPATIA_URL } from '@frontend/envConfig';
import { EmailTrigger } from '@frontend/types/workflow-agent';

// Type for partial updates to email triggers
export type EmailTriggerUpdate = Partial<Omit<EmailTrigger, 'id' | 'type'>>;

export const updateEmailTrigger = async (
  url: string,
  updates: EmailTriggerUpdate
): Promise<EmailTrigger> => {
  const { email_address, ...rest } = updates;
  console.warn('email_address', email_address);
  console.warn('rest', rest);
  const response = await http.patch<EmailTrigger>(url, rest);
  return response.data;
};

export const createEmailTrigger = async (
  agentId: string,
  instanceId: string,
  trigger: Record<string, unknown>
): Promise<EmailTrigger> => {
  const url = `${HYPATIA_URL}/api/v1/${instanceId}/agents/workflows/${agentId}/triggers/email`;
  const response = await http.post<EmailTrigger>(url, trigger);
  return response.data;
};

export const getEmailTrigger = async (url: string): Promise<EmailTrigger> => {
  const response = await http.get<EmailTrigger>(url);
  return response.data;
};

export const deleteEmailTrigger = async (url: string): Promise<void> => {
  await http.delete(url);
};
